import { FACTORY_OPTIONS, type FactoryCode } from '@/lib/factories';
import type { FilterSchema } from '@/lib/filters';

export function bulkTrimCardFilters(factory: FactoryCode): FilterSchema {
  return [
    {
      type: 'select',
      name: 'factory',
      label: 'Factory',
      required: true,
      options: FACTORY_OPTIONS,
      defaultValue: factory,
    },
    {
      type: 'text',
      name: 'b_number',
      label: 'B Number',
      required: true,
      placeholder: 'e.g. BF72566',
    },
  ];
}
